import type * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * A loading placeholder shaped like the thing that is coming.
 *
 * No shimmer animation: three of these on a screen animating out of phase is
 * noise, and `prefers-reduced-motion` would switch it off anyway. A calm block
 * at the right size communicates the same thing.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-md bg-surface-2', className)} {...props} />
}
